'use client'

// Preline Init component disabled to fix module parsing errors
// This component was causing TypeScript parsing issues with Preline library

export default function PrelineInit() {
  // Component disabled - no Preline initialization
  return null
}
